import { render, staticRenderFns } from "./CardNovaUnimed.vue?vue&type=template&id=d6b88ae6&scoped=true"
import script from "./CardNovaUnimed.vue?vue&type=script&lang=js"
export * from "./CardNovaUnimed.vue?vue&type=script&lang=js"
import style0 from "./CardNovaUnimed.vue?vue&type=style&index=0&id=d6b88ae6&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d6b88ae6",
  null
  
)

export default component.exports